import React, { useContext } from "react";
import AppContext from "../../../context/AppContext";
import { FaChartBar } from "react-icons/fa"; // Icon suggestion; replace if needed
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from "powerbi-client";

const translations = {
    en: {
        powerbi_dashboard: "PowerBI Dashboard",
        powerbi_embed: "Your PowerBI dashboard will appear here.",
    },
    ar: {
        powerbi_dashboard: "لوحة معلومات PowerBI",
        powerbi_embed: "سيظهر لوحة معلومات PowerBI هنا.",
    },
};

const PowerBIDashboard = () => {
    const { theme, langMode } = useContext(AppContext);

    const containerClass = `bg-white rounded-lg shadow-md w-full
    ${theme === "dark" ? "bg-gray-800 text-gray-300" : "bg-white text-gray-700"}
    `;

    return (
        <div className="flex flex-col items-center w-full justify-center min-h-screen">

            <div className={containerClass}>
                <PowerBIEmbed
                    embedConfig={{
                        type: 'report',   // Supported types: report, dashboard, tile, visual, qna, paginated report and create
                        id: '72c64e34-b451-4a2b-8cb6-31c1c0cc2339',
                        embedUrl: "https://app.powerbi.com/reportEmbed?reportId=72c64e34-b451-4a2b-8cb6-31c1c0cc2339&groupId=053afa7d-752c-45e7-b8cc-96ae5d077ec8&w=2&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLVNPVVRILUVBU1QtQVNJQS1yZWRpcmVjdC5hbmFseXNpcy53aW5kb3dzLm5ldCIsImVtYmVkRmVhdHVyZXMiOnsidXNhZ2VNZXRyaWNzVk5leHQiOnRydWV9fQ%3d%3d",
                        accessToken: 'H4sIAAAAAAAEACXSx46EVhQE0H-ZLZbI0FjyAmhyzmFHExt45Gz53z2W91cq1an794-d3f2YFT9__mThWFZjmKimrwVxrt5Wm5xYOg-nzcZE3nryt7OgrMWIztwl7Ljz2D1jbKGXJ0GJ8fT6W3DnSADzsiYKooaZcFo1G5-TSZxKIWVfbodqUfbZd6S9jF7I8UtZUARHJa7Dvt7mZ3F_-g3-Rm-pVEL3YvSM_pRsZr7gV2lxvTHFWQTDylP5OFAVY5_dxAPwEaOIhpOP48YwQShpUwWnnS0kzfD-ITSSkX1HpSQg--pelqrlzKAgqGe_dheeWmcIDjVjZMto4xSLry26UAK6fSH_RFXW7PWHEkU0OfiONpIUXNHtUNjrV0FcsGyTPrvxIp470RzDGuRaf4P-ucpwX86gDotwFVvBgaQDzRVhntP7O3wUfbgTr7GqzQsYOqHBFMXHTn3Wd5ATzSGXaio0fP8eapYqOUfbvtNjGEYPF1APrwX1dO8lWnNaoxWzbSuWNNuRDpBEbK2YvwgNlcpXHNxQalgMzwxrlUJg2Mkpp9vaTFCnjzTGSno0dIaFsnoHbT6Fo4Z5sHqkqiYTfQuUguW7zPgQoLQU13SeThi0e0Cgxu8k5iJd9Pmv4SP9yKxjZwiIUp_KLX0HlKF7N0RIGh8-Eu5W6XkT8yvf6ou8aWbUymVTCpOmlYjO4QYBFaeYIslFh__4N2j1BSum4Rz1t0yYuOgXbEOo2pGzG09GEiIBbNDH2_UMyuD3vCBQzJ4e-iUSe2zCME9P7iCxIPGcztCk5IGKDjh__fXzxw-_3NP2G3__vjnfDD5vkYLP5fT4lmCfkoFIUOsb0O-P2B-A16EJO1mmSjD8eHO5MCy7SyP-fBThh3o9QPbJnmdIInDwjGKA712z4PPm075F8RuuVq-n56sy3cJMMKpz6rIcsoXWYig_7an3IAGlS_O8r62bHPhoZVUg-HluOgY-Sv5VoKprzXrnI9_-Mqp9I1aeCpAz3qMQX_yJ84_s_ipk5cIFWwibMpRWOogQUKo-xzuJvwQl2UJbqU6KW7sDvnSQAH3wIcrqvtAbPIanLhNbFGSTVhqhwijzDNBpu5Bqt3vJV1nrnCmEtYeVb1mN41ntLXB95C4PRAAC26J2ivqOGTeezGrqxMMP9f_M99SUixL-KgdrcEyMo5qC022k45EsZIf_j-F96yHb9qX8PbNNzsjrKopVXabBjeBxQSKih5Rn1PrnPFybypaD_GJF-WbhT1Y6_OfCTWkcW5czsPVcZc4kyXxoyCYs7SHO98axedmngIyeYZAn9Jxl79FrtLk6Jz5KYVFIb25N6M5coH7gQZ18xCtZdAN4r0yuL1NKEK9xxiv3UMcG6jbKOIS4vx2auSsQxOJwMdpbejHIJE4IjvHcu2uBNy5Atpub0SQG9K1iJcutklfg9ZdIGPCjPU80v65SBBjueB2INHXeAkPVraglKzJNDmv58FCxIg2DsEWol23f8iBypydjVDAeoDrhOSnxd12wA4u_sNLWtf4QWqriR2U_bQknHebTedR_zP_8C3Y-PmjaBQAA.eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLVNPVVRILUVBU1QtQVNJQS1yZWRpcmVjdC5hbmFseXNpcy53aW5kb3dzLm5ldCIsImV4cCI6MTczMTUyNjc4NiwiYWxsb3dBY2Nlc3NPdmVyUHVibGljSW50ZXJuZXQiOnRydWV9',
                        tokenType: models.TokenType.Embed, // Use models.TokenType.Aad for SaaS embed
                        settings: {
                            panes: { filters: { visible: false } },
                            background: models.BackgroundType.Transparent,
                        }
                    }}

                    eventHandlers={
                        new Map([
                            ['loaded', function () { console.log('Report loaded'); }],
                            ['rendered', function () { console.log('Report rendered'); }],
                            ['error', function (event) { console.log(event.detail); }],
                            ['visualClicked', () => console.log('visual clicked')],
                            ['pageChanged', (event) => console.log(event)],
                        ])
                    }

                    cssClassName={"reportClass h-[800px] border-none shadow-none bg-[#f3f4f6]"}

                    getEmbeddedComponent={(embeddedReport) => {
                        window.report = embeddedReport;
                    }}
                />
            </div>

        </div>
    );
};

export default PowerBIDashboard;
